import React from 'react';
import Stack from '@mui/material/Stack';
import confirmingData from '../../constants/products/confirming';
import ProductHero from './components/ProductHero';
import ProductSection from './components/ProductSection';
import RecommendationSection from './components/RecommendationSection';
import { STACK_PRODUCT_SECTION_COMPONENT } from '../../constants/mui-components';

function Confirming() {
  return (
    <>
      <ProductHero productData={confirmingData} />
      <Stack className={STACK_PRODUCT_SECTION_COMPONENT}>
        <ProductSection productData={confirmingData.description_information} />
        <ProductSection
          productData={confirmingData.benefits_information}
          flexDirection="row-reverse"
        />
        <RecommendationSection actualProductName={confirmingData.name} />
      </Stack>
    </>
  );
}

export default Confirming;
